import {getAppLang, getProperty, getUserToken} from "../../../../utils";
import axios from "axios";
import {GOOGLE_RATING_GET} from "../../../../constants/api.constants";
import {googleRatingConstants} from "../../../../constants/General/googleRating.constants";

export function getGoogleRating() {

    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
            'authToken': getUserToken(),
            'language': getAppLang(),
        },
        body: {
            params: {
                property_id: getProperty(),
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'GOOGLE_RATING_GET',
            payload: axios.post(GOOGLE_RATING_GET, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data)
        })
    }
}

export function clearGoogleRating() {
    return dispatch => {
        dispatch({
            type: googleRatingConstants.GOOGLE_RATING_CLEAR,
        })
    }
}
